import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmacion-dialog',
  //standalone: true,
  //imports: [],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss'
})
export class ConfirmDialogComponent {

  loadingModal: boolean = false
  model : any = {};
  step = 1
  message
  description
  confirmButton

  constructor( 
    @Inject(MAT_DIALOG_DATA) 
    public data, 
    public dialogRef: MatDialogRef<ConfirmDialogComponent>) {
      this.message = data.message
      this.confirmButton = data.confirmButton
      this.description = data.description
  }

  nextStep(){
    this.step ++
  }
  
  ngOnInit() { }

  // Cierras el modal con el event 2 para que el padre sepa que no se puede enviar al back la data
  closeDialog() {
    this.dialogRef.close({event: 2});
  }
  // Cierras el modal con el event 1 para que el padre sepa que se puede enviar al back la data
  save(){
    this.loadingModal = true
    this.dialogRef.close({event: 1});
  }

}